<div class="vertical-large basic-card resume-body" [ngClass]="getClassList()">
  <!-- <nz-tag class="call-count" [nzColor]="'purple'" [nzBordered]="false">Call Count: 10</nz-tag> -->
  @if (sessionTemplate) {
    <h3 class="title" [matTooltip]="sessionTemplate.title ?? ''">
      {{ sessionTemplate.title ?? ' ' }}
    </h3>

    <div class="horizontal-large">
      <div class="portrait-container">
        <img class="portrait" [src]="resume()?.subData?.content?.portraitImageUrl" />
      </div>
      <div class="vertical no-gap">
        <div class="name">{{ resume()?.subData?.content?.firstName }} {{ resume()?.subData?.content?.lastName }}</div>
        <div class="position">
          {{ resume()?.subData?.content?.mostRecentPosition }} &#64; {{ resume()?.subData?.content?.mostRecentCompany }}
        </div>
        <div class="horizontal wrap">
          @for (personality of selectedPersonalityList(); track $index) {
            <nz-tag [nzBordered]="false" [nzColor]="personality?.unsafeSubData?.color">{{ personality?.title }}</nz-tag>
          }
        </div>
      </div>
    </div>

    <div class="vertical">
      <div class="horizontal align-top">
        <div class="profile-sub-title">Sales Cycle</div>
        <div class="horizontal wrap">
          {{ getSalesCycle(sessionTemplate.unsafeSubData?.salesCycleId) }}
        </div>
      </div>

      <!-- <div class="horizontal align-top">
        <div class="profile-sub-title">Called</div>
        <div class="horizontal wrap">{{ sessionTemplate.publicSubData?.usedCount }} times</div>
      </div> -->
    </div>

    <!-- <div class="horizontal">
      <div>Talk with</div>
      <div class="portrait-container-small">
        <img class="portrait-small" [src]="resume.subData.content?.portraitImageUrl" />
      </div>
      <div>{{ resume.subData.content?.firstName }}</div>
    </div> -->

    <!-- <div class="horizontal called">
          <div>Called {{ sessionTemplate.publicSubData?.usedCount ?? 0 }} Times</div>
          <button nz-button nzType="default" nzSize="small">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">lists</span>
            View Calls
          </button>
        </div> -->
    @if (!selectable) {
      <div class="start-call">
        <app-phone-call-button (click)="onStartCallClick(sessionTemplate, $event)"></app-phone-call-button>
      </div>
    }
  }
</div>

@if (!selectable && editable) {
  <div class="vertical edit-button">
    <button nz-button nzType="default" nzSize="default" [nzDanger]="false" (click)="onEditClick()">
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
      Edit
    </button>

    <button nz-button nzType="default" nzSize="default" [nzDanger]="false" (click)="onCopyClick()">
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">content_copy</span>
      Duplicate
    </button>
  </div>
}

<app-new-edit-session-template
  [sessionTemplate]="sessionTemplate"
  [isEdit]="true"
  [(isVisible)]="isEditSessionTemplateVisible"
></app-new-edit-session-template>
